
//Content types
export const contentTypes = {
  COURSE: 'course',
  NUDGE: 'nudge',
  SURVEY: 'survey',
}
